<template>
  <div>
    <div v-for="(item, index) in mapList" :key="index">
      <div :class="gameImgAreaClass()">
        <div  v-for="(subItem, subIndex) in item" :key="subIndex" :id="getLinesId(index,subIndex)"
             :class="{ box:true, h_top: gameTopClass(subIndex), h_bottom: gameBottomClass(subIndex) }">
          <img  :src="require('../../../assets/'+ gamePath +'/' + subItem + '.png')" alt=""
                :class=" { deep: matchDeepColor(index, subIndex) || matchDeppFreeColor(index, subIndex) || matchScatterWin(subItem) } ">
        </div>
      </div>
      <div :class="gameImgDetailClass()">
        <div class="box" v-for="(item, subIndex) in mapListDetail[index]" :key="subIndex">
          <img :src="require('../../../assets/'+ gamePath +'/' + item.key + '.png')" alt="" :class="{ deep: true }">
          <p>x {{item.lines}} ({{item.length}})</p>
          <p v-if="item.winInfo !=null">{{item.winInfo}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {slots_tool} from "../slots_tool";
  import SlotsDetailLayout from "./slots_detail_layout.vue";
  export default
  {
    name: "SlotsMapsDetailLayout",
    components: {SlotsDetailLayout},
    props: {
      gamePath:"",
      mapIndex: [],
      mapList: [],
      mapListDetail: [],
      linesId:"s",
      isFree: false,
      Phone:false,
      checkFreeColor: false,
      remainFreeCount:3,
      sumRows:3,
      sumColumns:5,
      freeId:'S',
      imgAreaClassId:"",
      imgImgDetailClassId:"",
      mapTopClass:[],
      mapBottomClass:[],
      checkScatterWin: false,
      scatterWin:false,
      scatterItem:"S",
      isCheckTable: false,
      checkTable:  [],
    },
    data() {
      return {

      };
    },
    created() {
      console.log(this.mapList);
    },
    methods: {
      matchDeepColor(index, subIndex)
      {
        return slots_tool.matchSubDeepColor(this.mapIndex,index,subIndex);
      },
      matchDeppFreeColor(index, subIndex)
      {
        if(this.isCheckTable)
        {
          return slots_tool.matchSubDeppFreeColorTable(index,
            subIndex,
            this.freeId,
            this.mapList,
            this.remainFreeCount,
            this.checkFreeColor,
            this.checkTable,
          )
        }
        else
        {
          return slots_tool.matchSubDeppFreeColor(index,
            subIndex,
            this.freeId,
            this.mapList,
            this.remainFreeCount,
            this.checkFreeColor,
            this.sumRows,
            this.sumColumns,
          )
        }

      },
      gameTopClass(index)
      {
        return slots_tool.checkIncludeIndex(this.mapTopClass,index);
      },
      gameBottomClass(index)
      {
        return slots_tool.checkIncludeIndex(this.mapBottomClass,index);
      },
      gameImgAreaClass()
      {
        return slots_tool.gameImgAreaClass(this.imgAreaClassId);
      },
      gameImgDetailClass()
      {
        return slots_tool.gameImgDetailClass(this.imgImgDetailClassId);
      },
      getLinesId(index,subIndex)
      {
        return slots_tool.setMapsLineIdName(this.linesId,index,subIndex);
      },
      matchScatterWin(item)
      {
        return slots_tool.matchScatterWin(item,this.scatterWin,this.checkScatterWin,this.scatterItem)
      },
    }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_maps_detail_layout.vue